// TODO: @josh - can we deprecate in place of the Portal in the design system
import React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode;
};

function ReactPortal({ children }: Props) {
  return ReactDOM.createPortal(children, document.getElementById('reactportal'));
}

export default ReactPortal;
